import './player_autocomplete.js';

(function ($) {
    'use strict';

    window.init_accounts = function(options) {
        var VEHICLE_TABLE_SELECTOR = '.js-vehicle-table';
        var TABLE_SORTABLE_COL_SELECTOR = '.js-table-sortable-col';
        var NAMESPACE = '.vehicleTable';
        var CLAN_INVITE_BUTTON_SELECTOR = '.js-clans_button__invite';
        var INVITATION_SENT_SELECTOR = '.js-clans-invitation-sent';

        var HIDDEN_TABLE_CLASS = 'table_hide';

        var vehicleTable = function (element) {
            var self = this;

            self.$element = $(element);
            self.$tableDropdownLinks = undefined;

            self.enableSorter = function () {

                // https://mottie.github.io/tablesorter/docs/
                self.$element.tablesorter({
                    sortList: [[1, 1]], // [[x,y],[x,y],..]  x represents column that's being sort by, y represents sorting order(0-asc, 1-desc)
                    sortInitialOrder: 'desc', // this is setting initial sorting order of all columns but the one above is more important
                    duplicateSpan: true,
                    headerTemplate: '', // The default template causes the header to be wrapped, conflating CSS
                    textExtraction: function(node) {
                        return $(node).attr('data-sort-value');
                    }
                });
            };

            self.init = function () {
                wg_ui.setTableColumnHover(NAMESPACE,TABLE_SORTABLE_COL_SELECTOR, VEHICLE_TABLE_SELECTOR);
                self.enableSorter();
            };
            self.init();
        };


        var SEARCH_RESULT_URL = String(window.SEARCH_RESULT_URL).replace(/search\/?$/i, '');
        var SEARCH_INPUT_SELECTOR = '.js-search-input';
        var AUTOCOMPLETE_WRAPPER_SELECTOR = '.js-autocomplete-wrapper';
        var AUTOCOMPLETE_VIEW_ALL_SELECTOR = '.js-autocomplete-view-all';
        var SEARCH_CLEAR_SELECTOR = '.js-search-clear';

        var autocompleteObj = window.player_autocomplete.activateAutocomplete({
            searchInputSelector: SEARCH_INPUT_SELECTOR,
            autocompleteWrapperSelector: AUTOCOMPLETE_WRAPPER_SELECTOR,
            autocompleteViewAllSelector: AUTOCOMPLETE_VIEW_ALL_SELECTOR,
            clearSelector: SEARCH_CLEAR_SELECTOR,
            changeLocation: false,
            submitHandler: function () {
                window.location = SEARCH_RESULT_URL + "?query=" + $(SEARCH_INPUT_SELECTOR).val();
            }

        });

        $('ul.era_tabs li.era_tabs_item').on('click tap', function (evt) {
            evt.preventDefault();
            var $activeSelection = $('ul.era_tabs .item__active');
            var $currentEra = $(this).attr('data-era');
            var $currentType = document.getElementsByClassName('vehicle_tabs_item item__active')[0].dataset['vehicleType'];
            var $combinedType = $currentType + '_' + $currentEra;
            var $ltTab = document.getElementById('lightTank');
            var $artilleryTab = document.getElementById('SPG');

            $activeSelection.removeClass('item__active');
            $(this).toggleClass('item__active');
            if ($currentEra == 'coldwar') {
                $artilleryTab.style.visibility = 'hidden';
                $artilleryTab.className = 'vehicle_tabs_item';
                if ($currentType == 'SPG') {
                    $combinedType = 'lightTank_coldwar';
                    $ltTab.className = 'vehicle_tabs_item item__active';

                }
            } else {
                $artilleryTab.style.visibility = 'visible';
            }
            // hiding currently active vehicle group and it's total
            $('.js-tank-tab').addClass(HIDDEN_TABLE_CLASS);
            $('.js-tank-tab-total').addClass(HIDDEN_TABLE_CLASS);
            $('.js-tank-tab').removeClass('item__active');

            // showing currently selected vehicle group and it's total
            $('.js-tank-tab[data-vehicle-type=' + $combinedType + ']').removeClass(HIDDEN_TABLE_CLASS);
            $('.js-tank-tab-total[data-vehicle-type=' + $combinedType + ']').removeClass(HIDDEN_TABLE_CLASS);
            $('.js-tank-tab-total[data-vehicle-type=' + $combinedType + ']').toggleClass('item__active');

        });

        $('ul.vehicle_tabs li.vehicle_tabs_item').on('click tap', function (evt) {
            evt.preventDefault();
            var $activeSelection = $('ul.vehicle_tabs .item__active');
            var $currentType = $(this).attr('data-vehicle-type');
            var $currentEra = document.getElementsByClassName('era_tabs_item item__active')[0].dataset['era'];
            var $combinedType = $currentType + '_' + $currentEra;
            var $activeSelectionTable = $('.js-tank-tab[data-vehicle-type=' + $combinedType + ']');
            var $activeSelectionTableTotal = $('.js-tank-tab-total[data-vehicle-type=' + $combinedType + ']');

            // hiding currently active vehicle group and it's total
            $('.js-tank-tab').addClass(HIDDEN_TABLE_CLASS);
            $('.js-tank-tab-total').addClass(HIDDEN_TABLE_CLASS);
            $activeSelection.removeClass('item__active');

            // showing currently selected vehicle group and it's total
            $('.js-tank-tab[data-vehicle-type=' + $combinedType + ']').removeClass(HIDDEN_TABLE_CLASS);
            $('.js-tank-tab-total[data-vehicle-type=' + $combinedType + ']').removeClass(HIDDEN_TABLE_CLASS);
            $(this).toggleClass('item__active');
        });

        $('tr.js-have-childRow .table_switcher').on('click tap', function (evt) {
            evt.preventDefault();
            var ROW_HAS_VEHICLE_DETAILS = 'js-have-vehicle-details';
            var $row = $(this).parents('tr');
            if (!$row.hasClass(ROW_HAS_VEHICLE_DETAILS)) {
                $row.addClass(ROW_HAS_VEHICLE_DETAILS);
                var vehicle_cd = $row.data('vehicle-cd');
                var destination = $('td div', $row.next());
                wg_modal.showThrobber(destination, true);
                $.ajax({
                    data: {'vehicle_cd': vehicle_cd},
                    dataType: 'html',
                    error: function (data) {
                        wg_modal.hideThrobber(destination);
                        $row.removeClass(ROW_HAS_VEHICLE_DETAILS);
                    },
                    success: function (data) {
                        $(destination).append(data);
                        wg_modal.hideThrobber(destination);
                    },
                    url: options.vehicle_details_url
                });
            }
            $('.js-tablesorter-childRow-switcher', $row).each(function () {
                $(this).toggleClass('table_switcher__opened');
            });
            $row.next('tr.tablesorter-childRow').toggle(0);
        });

        new vehicleTable($(VEHICLE_TABLE_SELECTOR));

        $(CLAN_INVITE_BUTTON_SELECTOR).removeAttr('disabled').on("click tap", function () {
            var clanName = window.clan_info.clan.name;
            wg_modal.showConfirm(
                gettext('Invite to %s').replace('%s', clanName) + '?',
                '<p>' + gettext('Are you sure you want to invite {username} to {clantag}?')
                    .replace('{username}', window.account_name)
                    .replace('{clantag}', clanName) + '</p>',
                gettext('Invite'),
                function () {
                    clans.callEndpoint({
                        endpoint: 'send_invite',
                        data: {'clan_id': window.clan_info.clan.id, 'account_id': window.account_id},
                        success: function (data) {
                            $(INVITATION_SENT_SELECTOR).show();
                            $(CLAN_INVITE_BUTTON_SELECTOR).hide();
                            wg_modal.hideThrobber();
                        },
                        fail: null // Use default handler for error message

                    })

                });

        });
    };


})(jQuery);
